import { NavLink, Outlet } from 'react-router'
import { useAppStore } from '@/store'

const YEARS = ['2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015']

const navLinks = [
  { to: '/', label: 'Tableau de bord' },
  { to: '/recettes', label: 'Recettes' },
  { to: '/depenses', label: 'Dépenses' },
  { to: '/comparaisons', label: 'Comparaisons UE' },
  { to: '/ask', label: 'Questions' },
]

export default function Layout() {
  const { selectedYear, setSelectedYear, darkMode, toggleDarkMode } = useAppStore()

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-nav-dark text-white px-6 py-3 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <h1 className="text-lg font-bold tracking-tight">
            🇫🇷 Taxes & Budget
          </h1>
          <nav className="flex items-center gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-nav text-white'
                      : 'text-white/70 hover:text-white hover:bg-white/10'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="ml-3 bg-white/10 text-white text-sm rounded px-2 py-1.5 border border-white/20 focus:outline-none focus:ring-2 focus:ring-accent cursor-pointer"
            >
              {YEARS.map((y) => (
                <option key={y} value={y} className="text-primary">
                  {y}
                </option>
              ))}
            </select>
            <button
              onClick={toggleDarkMode}
              className="ml-2 bg-white/10 text-white text-sm rounded px-2 py-1.5 border border-white/20 hover:bg-white/20 transition-colors cursor-pointer"
              aria-label={darkMode ? 'Passer en mode clair' : 'Passer en mode sombre'}
            >
              {darkMode ? '☀️' : '🌙'}
            </button>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-border px-6 py-3 text-center text-sm text-text-muted">
        Données : Eurostat · INSEE · DGFiP · data.gouv.fr · OpenFisca · OCDE
      </footer>
    </div>
  )
}
